/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react';
import { Breadcrumb, Button, Empty, Popconfirm, Tooltip } from 'antd';
import { NavLink } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { MdDeleteOutline, MdModeEditOutline } from 'react-icons/md';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import {
  Container,
  Testimonial,
  TestimonialsList,
  TestimonialsListContent,
  Pagination,
  TestimonialActions,
  TestimonialContent,
} from './styles';
import { PageTitle } from '../../components/PageTitle';
import styles from './Depoimentos.module.css';
import { api } from '../../services/api';
import { Loading } from '../../components/Loading';
import { Filters } from './Filters';
import {
  TestimonialAvatar,
  TestimonialContainer,
} from '../ProductUpdate/styles';
import { TestimonialSearch } from '../TechnicalTeam/styles';

export function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [testimonialsTotal, setTestimonialsTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isShowHomeFilter, setIsShowHomeFilter] = useState(false);
  const [checkedFilters, setCheckedFilters] = useState([]);
  const [isSortLoading, setIsSortLoading] = useState(false);
  const [searchWord, setSearchWord] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  const [filtersLoaded, setFiltersLoaded] = useState(false);

  function stringAvatar(name) {
    const nameParts = name.split(' ');

    if (nameParts.length === 1) {
      return `${nameParts[0][0]}${nameParts[0][0]}`.toUpperCase();
    }

    return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase();
  }

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  const [paginationPage, setPaginationPage] = useState(1);

  async function loadTestimonials() {
    try {
      setLoading(true);
      const response = await api.get(
        `/testimonials/all?page=${paginationPage}`,
      );
      setTestimonialsTotal(response.data.total);
      setTestimonials(response.data.testimonials);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Erro ao buscar depoimentos');
    }
  }

  async function deleteTestimonial(testimonailId) {
    try {
      await api.delete(`/testimonials/${testimonailId}`);
      loadTestimonials();
      toast.success('Depoimento removido com sucesso');
    } catch (error) {
      setLoading(false);
      toast.error('Erro remover depoimento');
    }
  }

  async function sortTestimonial() {
    try {
      setIsSortLoading(true);
      await api.post('/testimonials/sort-home', {
        testimonials,
      });
      setIsSortLoading(false);
      toast.success('Depoimento ordenado com sucesso');
    } catch (error) {
      console.log(error);
      setIsSortLoading(false);

      toast.error('Erro ao ordenar depoimentos');
    }
  }

  async function searchTechnicalTeam() {
    try {
      const isShowHome = checkedFilters.includes('is_show_home');
      setLoading(true);
      setIsSearching(true);

      const response = await api.get(
        `/testimonials/search/?is_show_home=${isShowHome}&search_word=${searchWord}`,
      );

      setTestimonials(response.data);
      setIsShowHomeFilter(isShowHome);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Erro ao buscar corpo técnico');
    }
  }

  useEffect(() => {
    if (!filtersLoaded) return;

    if (isSearching) {
      searchTechnicalTeam();
    } else {
      loadTestimonials();
    }
  }, [filtersLoaded, isSearching, paginationPage]);

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(testimonials);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setTestimonials(items);
  }

  function clearSearch() {
    setSearchWord('');
    setIsSearching(false);
    setIsShowHomeFilter(false);
    setCheckedFilters([]);
    loadTestimonials();
  }

  useEffect(() => {
    const savedFilters = localStorage.getItem('testimonialsFilters');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      console.log('filters', filters);
      setSearchWord(filters.searchWord || '');
      setIsSearching(filters.isSearching || false);
      setPaginationPage(filters.paginationPage || 1);
    }

    setFiltersLoaded(true);
  }, []);

  useEffect(() => {
    if (!filtersLoaded) return;

    const filters = {
      searchWord,
      isSearching,
      isShowHomeFilter,
      paginationPage,
    };

    localStorage.setItem('testimonialsFilters', JSON.stringify(filters));
  }, [
    searchWord,
    isSearching,
    isShowHomeFilter,
    filtersLoaded,
    paginationPage,
  ]);

  return (
    <Container>
      <Breadcrumb style={{ marginBottom: 40 }}>
        <Breadcrumb.Item key="/">
          <NavLink to="/">
            <HomeOutlined />
          </NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Depoimentos</Breadcrumb.Item>
      </Breadcrumb>

      <PageTitle
        title="Depoimentos"
        description="Gerenciamento de depoimentos"
        link="/depoimentos/criar"
        linkTitle="Cadastrar depoimento"
      />

      <Filters
        checkedFilters={checkedFilters}
        setCheckedFilters={setCheckedFilters}
        searchTechnicalTeam={searchTechnicalTeam}
        sortTestimonial={sortTestimonial}
        isSortLoading={isSortLoading}
        searchWord={searchWord}
        setSearchWord={setSearchWord}
        clearSearch={clearSearch}
      />

      {!loading && !!testimonials.length && !isShowHomeFilter && (
        <>
          <TestimonialsList>
            <TestimonialsListContent>
              {testimonials.map((item) => (
                <Testimonial key={item.name}>
                  <TestimonialContent>
                    <p className={styles.name}>{item.name}</p>
                    {item.photo_url ? (
                      <img
                        className={styles.avatar}
                        src={item.photo_url}
                        style={{ width: 50, height: 50 }}
                        alt=""
                      />
                    ) : (
                      <div
                        className={styles.avatarName}
                        style={{ background: stringToColor(item.name) }}
                      >
                        {stringAvatar(item.name)}
                      </div>
                    )}

                    <p className={styles.textDepoiment}>{item.text}</p>
                    {
                      item.video_url && (
                        <span>Vídeo</span>
                      )
                    }
                  </TestimonialContent>

                  <TestimonialActions>
                    <Tooltip title="Editar produto">
                      <NavLink to={`/depoimentos/atualizar/${item.id}`}>
                        <Button
                          icon={<MdModeEditOutline size={20} color="#fff" />}
                          style={{ background: '#1677ff' }}
                        />
                      </NavLink>
                    </Tooltip>

                    <Tooltip title="Remover produto">
                      <Popconfirm
                        title="Remover depoimentos"
                        description="Tem certeza que deseja remover depoimento ?"
                        onConfirm={() => deleteTestimonial(item.id)}
                        okText="Confirmar"
                        cancelText="Não"
                      >
                        <Button
                          icon={<MdDeleteOutline size={20} color="#fff" />}
                          style={{ background: '#ff4d4f', marginLeft: 15 }}
                        />
                      </Popconfirm>
                    </Tooltip>
                  </TestimonialActions>
                </Testimonial>
              ))}
            </TestimonialsListContent>
          </TestimonialsList>

          {
            !isSearching && (
              <Pagination
                onChange={setPaginationPage}
                current={paginationPage}
                total={testimonialsTotal}
                showSizeChanger={false}
                defaultPageSize={6}
              />
            )
          }

        </>
      )}

      {isShowHomeFilter && (
        <TestimonialContainer>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="characters">
              {(provided) => (
                <div
                  className={styles.moduleList}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {!!testimonials.length &&
                    testimonials.map((productTestimonial, index) => (
                      <Draggable
                        key={productTestimonial.id}
                        draggableId={productTestimonial.id}
                        index={index}
                      >
                        {(providedDrag) => (
                          <TestimonialSearch
                            ref={providedDrag.innerRef}
                            {...providedDrag.draggableProps}
                            {...providedDrag.dragHandleProps}
                            className={styles.moduleListItem}
                          >
                            <div>
                              {productTestimonial.photo_url ? (
                                <img
                                  src={productTestimonial.photo_url}
                                  style={{ width: 50, height: 50 }}
                                  alt=""
                                />
                              ) : (
                                <TestimonialAvatar
                                  style={{
                                    background: stringToColor(
                                      productTestimonial.name || '',
                                    ),
                                  }}
                                >
                                  {stringAvatar(productTestimonial.name || '')}
                                </TestimonialAvatar>
                              )}

                              <div className="info">
                                <span>{productTestimonial.name}</span>
                                <p>{productTestimonial.text}</p>
                              </div>
                            </div>

                            <TestimonialActions>
                              <Tooltip title="Editar depoimento">
                                <NavLink
                                  to={`/depoimentos/atualizar/${productTestimonial.id}`}
                                >
                                  <Button
                                    icon={(
                                      <MdModeEditOutline
                                        size={20}
                                        color="#fff"
                                      />
                                    )}
                                    style={{ background: '#1677ff' }}
                                  />
                                </NavLink>
                              </Tooltip>

                              <Tooltip title="Remover depoimento">
                                <Popconfirm
                                  title="Remover depoimento"
                                  description="Tem certeza que deseja remover depoimento ?"
                                  onConfirm={() =>
                                    deleteTestimonial(productTestimonial.id)}
                                  okText="Confirmar"
                                  cancelText="Não"
                                >
                                  <Button
                                    icon={
                                      <MdDeleteOutline size={20} color="#fff" />
                                    }
                                    style={{
                                      background: '#ff4d4f',
                                      marginLeft: 15,
                                    }}
                                  />
                                </Popconfirm>
                              </Tooltip>
                            </TestimonialActions>
                          </TestimonialSearch>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          {!testimonials.length && (
            <Empty
              style={{ padding: '40px 0 ' }}
              description="Nenhum depoimento encontrado"
            />
          )}
        </TestimonialContainer>
      )}

      {loading && <Loading />}
    </Container>
  );
}
